// NOTE: These German translations are an AI-generated best-effort draft
// (produced to replace a long-standing "<English text> (German)"
// placeholder that spanned this entire file). They have NOT been reviewed
// by a native German speaker or a professional translator - treat as a
// starting point only, not production-ready localization. Please have
// someone fluent in German review this file before relying on it.
export default {
  /* Global */
  documentation: 'Dokumentation',
  copied: 'Erfolgreich kopiert.',
  copyFailed: 'Kopieren fehlgeschlagen.',
  login: 'Anmelden',
  logout: 'Abmelden',
  privacyPolicyConfirmation:
    'Bitte bestätigen Sie, dass Sie unsere Datenschutzrichtlinie zur Datennutzung und zum Datenschutz gelesen und verstanden haben.',

  /* MainNavigation */
  onboarding: 'Onboarding',
  products: 'Produkte',
  governance: 'Governance',
  organizations: 'Organisationen',
  organization: 'Organisation',
  reports: 'Berichte',
  compute: 'Compute',
  myProducts: 'Meine Produkte',
  productSpecification: 'Produktspezifikation',
  order: 'Bestellen',
  freeTrial: 'Kostenlose Testversion',
  caas: 'CaaS',
  myClusters: 'Meine Cluster',
  baremetal: 'BareMetal',
  helpFeedback: 'Hilfe & Feedback',

  /* Product Specification pages (Compute/CaaS/BareMetal markdown pages) */
  caasLogoAlt: 'CaaS-Logo',
  computeLogoAlt: 'Compute-Logo',
  computeProductSpecificationBreadcrumb: 'Compute-Produktspezifikation',
  bareMetalProductSpecificationBreadcrumb: 'BareMetal-Produktspezifikation',
  commercialProduct: 'Kommerzielles Produkt',
  evaluationProductLabel: 'Testprodukt',

  /* SidenNavigation */
  overview: 'Übersicht',
  users: 'Benutzer',
  projects: 'Projekte',
  juiceGroups: 'Juice Groups',
  caasCluster: 'CaaS-Cluster',
  onboardingUsers: 'Onboarding-Benutzer',
  tdiConnectPortal: 'TDI Connect Portal',
  profile: 'Profil',
  notifications: 'Benachrichtigungen',
  security: 'Sicherheit',
  docs: 'Dok.',
  help: 'Hilfe',
  whatsNew: 'Neuigkeiten',
  portalDocumentation: 'Portal-Dokumentation',
  helpAndFeedback: 'Hilfe & Feedback',

  /* Feedback Page */
  feedbackSuccess: 'Feedback erfolgreich gesendet!',
  caasupgradeSuccess: 'Upgrade erfolgreich gestartet!',
  attachmentSizeError:
    'Die Gesamtdateigröße überschreitet das Limit von 2 MB. Bitte reduzieren Sie die Anzahl oder Größe der Dateien.',
  feedbackTitle: 'Support & Feedback',
  feedbackDescription:
    'Ihr Feedback ist uns wichtig. Bitte teilen Sie uns Ihre Gedanken, Vorschläge oder Probleme mit.',
  feedbackTitleField: 'Titel',
  feedbackTitlePlaceholder: 'Feedback-Titel eingeben',
  feedbackDescriptionPlaceholder: 'Beschreiben Sie Ihr Feedback',
  feedbackTitleRequiredError: 'Titel ist erforderlich',
  feedbackDescriptionRequiredError: 'Beschreibung ist erforderlich',
  feedbackEmailRequiredError: 'E-Mail ist erforderlich',
  invalidEmailError: 'Ungültige E-Mail-Adresse',
  attachmentOptionalLabel: 'Anhang (Optional)',
  attachmentDescription:
    'Sie können mehrere Dateien (Bilder, PDF, Text, JSON) anhängen, um Ihr Feedback zu unterstützen.',
  attachmentInfoText:
    'Max. 1 MB pro Datei, 2 MB insgesamt. Akzeptierte Formate: Bilder, PDF, Text, JSON',
  openSupportAndFeedbackGuide: 'Support- und Feedback-Leitfaden öffnen',
  frequentlyAskedQuestions: 'Häufig gestellte Fragen',
  submitYourRequest: 'Ihre Anfrage senden',
  sendButton: 'Senden',
  faqFormPurposeQuestion: 'Wofür ist dieses Formular?',
  faqFormPurposeAnswer:
    'Um Probleme zu melden, Fragen zu stellen oder Vorschläge zum TDI-Connect-Portal und seinen Funktionen zu teilen.',
  faqWhenToUseQuestion: 'Wann sollte ich es verwenden?',
  faqWhenToUseAnswer:
    'Verwenden Sie es, wenn etwas nicht wie erwartet funktioniert, Sie eine Klärung benötigen oder eine Verbesserung vorschlagen möchten.',
  faqWhatNotToUseForQuestion: 'Wofür sollte ich es nicht verwenden?',
  faqWhatNotToUseForAnswer:
    'Nicht für Sicherheitsvorfälle, allgemeine IT-Probleme (VPN/Laptop/E-Mail) oder produktspezifischen Support, der von anderen Teams bearbeitet wird.',
  faqWhoReceivesSubmissionQuestion: 'Wer erhält meine Einreichung?',
  faqWhoReceivesSubmissionAnswer:
    'Das TDI-Connect-Team (Engineering, Produkt und Portal-Betreuer) prüft und leitet alle eingehenden Rückmeldungen weiter.',
  faqWhatInfoToIncludeQuestion: 'Welche Informationen sollte ich angeben?',
  faqWhatInfoToIncludeAnswer:
    'Beschreiben Sie das Problem klar, geben Sie Schritte zur Reproduktion, relevante Screenshots und Ihr Projekt oder Ihre Produktinstanz an.',
  faqFeedbackUsedQuestion: 'Wird mein Feedback verwendet?',
  faqFeedbackUsedAnswer:
    'Ja – jede Einreichung wird geprüft und hilft, Verbesserungen am Portal zu steuern.',

  /* Table */
  emptyTable: 'Keine Einträge vorhanden.',
  paginationRangeLabel: 'von',
  paginationRangeAriaLabel: 'Gehe zu',
  paginationRowsPerPageAriaLabel: 'Seitengröße auswählen',
  paginationRowsPerPageLabel: 'pro Seite',
  paginationRowsPerPageButtonAriaLabel: 'Elemente pro Seite auswählen',
  paginationSelectedAriaLabel: 'Aktuell ausgewählt',
  paginationPageAriaLabel: 'Aktuelle Seitenanzeige',

  /* Delete Modal */
  deleteMessage1: 'Möchten Sie {name} wirklich löschen?',
  deleteMessage2: 'Geben Sie zur Bestätigung Folgendes ein: ',

  /* Sign-in Change Banner */
  signInChangeBannerTitle: 'Wichtig: Die Anmeldung bei TDI Connect hat sich geändert',
  signInChangeBannerText:
    'Melden Sie sich mit Ihrer neuen Unternehmens-E-Mail-Adresse an. Wählen Sie Anmelden, geben Sie Ihre vollständige E-Mail-Adresse ein und folgen Sie den Anmeldeschritten Ihres Unternehmens, einschließlich eventueller Verifizierungsaufforderungen. Probleme bei der Anmeldung? Senden Sie eine Anfrage über das Support-Formular.',
  signInChangeBannerLink: 'Support-Formular',

  /* Cookie Banner */
  cookieBannerTitle: 'Cookie-Nutzung',
  cookieBannerCheckboxMessage1:
    'Durch das Aktivieren dieses Kästchens bestätigen Sie, dass Sie unsere ',
  cookieBannerCheckboxMessage2:
    ' gelesen und verstanden haben, die erklärt, wie wir Ihre personenbezogenen Daten erheben, verwenden und schützen.',

  /* Home Page */
  title: 'TDI Connect',
  iaasDescription:
    'Stärken Sie IT & Telco mit Cloud-Services für skalierbare, effiziente Abläufe in ganz Europa',
  computeTitle: 'Compute',
  computeSubheader: 'Skalierbare Rechenleistung für jede Workload',
  computeDescription:
    'Stellen Sie mühelos leistungsstarke Rechenressourcen in der Cloud bereit und skalieren Sie diese. Entwickelt für anspruchsvolle Workloads wie KI, Datenverarbeitung und Simulation — mit schneller Bereitstellung, flexibler Preisgestaltung und globaler Verfügbarkeit.',
  computeButtonText: 'Compute-Spezifikationen lesen',
  caasTitle: 'CaaS',
  caasSubheader: 'Container as a Service',
  caasDescription:
    'Bietet eine verwaltete Umgebung zur Bereitstellung und Skalierung containerisierter Anwendungen mithilfe von Kubernetes-Clustern über eine API. Unterstützt CaaS auf OpenStack (VM-basierte Cluster) oder BareMetal (dedizierte physische Servercluster).',
  caasButtonText: 'CaaS-Spezifikationen lesen',
  marketPlaceText: 'Unser Marktplatz',
  /* api key */
  apiKeyGenerated: 'API-Schlüssel erfolgreich generiert',
  apiKeyGenerationErr: 'Generierung des API-Schlüssels fehlgeschlagen',
  apiKeyCopy1: 'Bitte kopieren Sie diesen API-Schlüssel und bewahren Sie ihn sicher auf.',
  apiKeyCopy2: 'Sie können ihn danach nicht mehr einsehen.',

  /* users */
  userActivated: 'Benutzer wurde erfolgreich aktiviert.',
  userPasswordChanged: 'Passwort wurde erfolgreich geändert.',
  userPasswordMismatch: 'Passwörter stimmen nicht überein.',
  userPasswordResetEmail: 'Die E-Mail zum Zurücksetzen des Passworts wurde gesendet.',
  userPasswordReset:
    'Das Benutzerpasswort wurde erfolgreich gespeichert. Sie können sich jetzt anmelden.',
  cloudPasswordUpdate: 'Cloud-Passwort wurde erfolgreich aktualisiert.',
  userCreation: 'Benutzer wurde erfolgreich erstellt.',
  userDeleted: 'Benutzer wurde erfolgreich gelöscht.',
  userUpdated: 'Benutzer wurde erfolgreich aktualisiert.',
  userDeletePermissionErr: 'Sie haben keine Berechtigung, diesen Benutzer zu löschen.',
  userEditPermissionErr: 'Sie haben keine Berechtigung, diesen Benutzer zu bearbeiten.',
  userUnassignment1: 'Dieser Benutzer ist folgenden Produkten zugewiesen:',
  userUnassignment2: 'Wenn Sie fortfahren, wird der Benutzer von diesen Produkten getrennt.',
  userPendingOrgAssignment:
    'Dieser Benutzer wurde noch keiner Organisation zugewiesen. Die Bearbeitung ist erst nach Abschluss der Organisationszuweisung möglich.',
  userOnboardingRequired:
    'Dieser Benutzer hat das Onboarding noch nicht abgeschlossen. Die Bearbeitung ist erst nach Abschluss des Onboardings möglich.',
  userRoleManagedExternally:
    'Rollenänderungen sind hier nicht erlaubt - die Rolle wird außerhalb unserer Domäne verwaltet.',
  incorrectToken: 'Ungültiges Token',
  userActivationErr: 'Benutzeraktivierung fehlgeschlagen',
  userCreationPermissionErr: 'Sie haben keine Berechtigung, einen neuen Benutzer zu erstellen.',

  /* organizations */
  organizationCreation: 'Organisation wurde erfolgreich erstellt.',
  organizationUpdated: 'Organisation wurde erfolgreich aktualisiert.',
  organizationCreationPermissionErr:
    'Sie haben keine Berechtigung, eine neue Organisation zu erstellen.',
  editOrganizationDisabled: 'Sie haben keine Berechtigung, diese Organisation zu bearbeiten.',

  /* osprojects */
  createOsProjectFulfilled:
    'Ihr Produkt wird im Rechenzentrum vorbereitet. Dieser Vorgang dauert einige Minuten. Sie werden benachrichtigt, sobald das Produkt bereit ist, und der Dienststatus wird als aktiv angezeigt. Sie können auf alle Ihre aktiven Produkte (OpenStack-Projekte) mit einem Passwort pro Rechenzentrum zugreifen. Dieses Rechenzentrums-Passwort wird Ihnen per E-Mail zugesandt, wenn Sie Ihr erstes Produkt (OpenStack-Projekt) in einem jeweiligen Rechenzentrum erstellen. Falls Sie keine E-Mail mit einem Passwort erhalten haben oder Ihr Rechenzentrums-Passwort vergessen haben, können Sie es im Portal (unter Einstellungen) problemlos wiederherstellen – oder wenden Sie sich an unser Support-Team.',
  osProjectNameDuplicate: 'Dieser Projektname wird in der ausgewählten Cloud bereits verwendet',
  osProjectDeleted: 'Löschvorgang erfolgreich gestartet',
  osProjectSetDeleted: 'OS-Projekt erfolgreich gelöscht',
  osProjectPatchFailed: 'OS-Projekt konnte nicht als gelöscht markiert werden',
  osProjectDeleteDisabled:
    'Sie haben keine Berechtigung, dieses OS-Projekt als gelöscht zu markieren. Bitte wenden Sie sich an einen Administrator.',
  osProjectDeleteDisabledCreatedFromJuice:
    'Dieses OS-Projekt wurde aus Juice erstellt und kann nicht gelöscht werden.',
  osProjectsDeleteMessage:
    'Wenn Sie dieses OS-Projekt löschen, wird es auch aus OpenStack entfernt.',

  /* projects */
  projectCreation: 'Projekt wurde erfolgreich erstellt.',
  projectDeleted: 'Projekt wurde erfolgreich gelöscht.',
  projectEdit: 'Projekt wurde erfolgreich aktualisiert.',
  noUsageData: 'Es sind keine Nutzungsdaten vorhanden.',
  projectCreationPermissionErr: 'Sie haben keine Berechtigung, ein neues Projekt zu erstellen.',
  adminOrgActionDisabled: 'In der Admin-Organisation nicht erlaubt',
  editProjectDisabled: 'Sie haben keine Berechtigung, dieses Projekt zu bearbeiten.',
  deleteProjectPermissionErr: 'Sie haben keine Berechtigung, dieses Projekt zu löschen.',
  projectDeleteDisabled: 'Projekt kann nicht gelöscht werden.',
  projectDeleteDisabledHasProducts: 'Projekt mit vorhandenen Produkten kann nicht gelöscht werden.',

  /* products */
  productForecasts: 'Prognosen für Produkt {name}',
  productCreationPermissionErr: 'Sie haben keine Berechtigung, ein neues Produkt zu erstellen.',
  evaluationProductCreationDisabled: 'Sie können kein neues Evaluierungsprodukt erstellen.',
  productCreation: 'Produkt wurde erfolgreich erstellt.',
  productUpdated: 'Produkt wurde erfolgreich aktualisiert.',
  productDeleted: 'Produkt wurde erfolgreich gelöscht.',
  productDeleteDisabled:
    'Sie haben keine Berechtigung, dieses Produkt zu löschen. Bitte wenden Sie sich an einen Administrator',
  productDeleteUndoable: 'Dieser Produkttyp kann nicht gelöscht werden.',
  productDeleteDisabledOsProjects: 'In diesem Produkt sind bereits OS-Projekte vorhanden',
  productDeleteDisabledCaasClusters: 'In diesem Produkt sind bereits CaaS-Cluster vorhanden',
  productDeleteDisabledCaasBm: 'Produkte vom Typ „caasonbaremetal“ können nicht gelöscht werden',
  editProductDisabled: 'Sie haben keine Berechtigung, dieses Produkt zu bearbeiten.',
  productDeleteMessage:
    'Wenn Sie dieses Produkt löschen, wird auch die zugehörige Juice Group gelöscht.',

  /* Compute Order Text for Project and Resource Allocation */
  projectName: 'Ein benutzerfreundlicher Name zur Identifizierung des OS-Projekts.',
  projectDescription:
    'Die Initiative oder Aktivität Ihrer Organisation. Projekte können nur von Administratoren erstellt werden.',
  productDescription:
    'Untergeordnetes Element eines Projekts, das die Bereitstellung von Cloud-Ressourcen erfordert. Produkte können nur von Administratoren erstellt werden.',
  dataCenterDescription:
    'Von TDI betriebene Rechenzentren in Europa, die den DT-Standards entsprechen und nach einem georedundanten Standortkonzept organisiert sind.',
  virtualCPUsAndMemory:
    'Werte, die Ihrem OpenStack-Projekt zugewiesen werden. Die vCPUs werden mit einer Standard-Verarbeitungsleistung angeboten. Falls Sie eine Hochleistungsverarbeitung benötigen, wenden Sie sich bitte an unser Support-Team.',

  /* forecasts */
  forecastsNotFound:
    'In der Prognosedatenbank sind keine Informationen für diese Juice Group vorhanden. Sie können für dieses Projekt keine virtuelle Cloud erstellen.',
  forecastsApplySuccess: 'Prognose(n) erfolgreich angewendet',
  forecastsApplyFailure: 'Anwenden der Prognose(n) fehlgeschlagen',

  /* juiceGroup  info */
  editJuiceGroupInfo: 'JuiceGroup-Informationen bearbeiten',
  geoRedundancySet: 'Georedundanz wurde erfolgreich festgelegt',
  serviceAdded: 'Externer Dienst wurde erfolgreich hinzugefügt',
  serviceRemoved: 'Externer Dienst wurde erfolgreich entfernt',

  /* contact info */
  contactAdded: 'Kontaktinformationen wurden erfolgreich hinzugefügt',
  contactEdited: 'Kontaktinformationen wurden erfolgreich aktualisiert',
  contactRemoved: 'Kontaktinformationen wurden erfolgreich entfernt',
  contactCreateDisabled: 'Sie haben keine Berechtigung, einen Kontakt zu erstellen',
  contactEditDisabled: 'Sie haben keine Berechtigung, den Kontakt zu bearbeiten',
  contactDeleteDisabled: 'Sie haben keine Berechtigung, den Kontakt zu löschen',

  /* Notification Messages */
  duplicateContactValidation: 'Ein Kontakt mit dieser E-Mail-Adresse und Rolle existiert bereits.',

  /* Errors (app-specific - generic HTTP/backend error codes come from
     @piaas/piaas-ui-toolkit/i18n, merged in ../de.ts) */
  ERR_USER_DELETION_NOT_ENTITLED:
    'Der Benutzer hat keine Berechtigung, diese Benutzerrolle zu löschen',
  ERR_NAME_INVALID:
    'Der Name darf nur Kleinbuchstaben, Zahlen und Bindestriche enthalten (z. B. my-project)',
  ERR_ORG_NAME_INVALID:
    'Der Organisationsname darf nur Kleinbuchstaben, Zahlen und Bindestriche enthalten (z. B. my-org)',
  ERR_PASSWORD_INVALID:
    'Ihr Passwort sollte mindestens 10 Zeichen, 1 Großbuchstaben, 1 Kleinbuchstaben, 1 Ziffer und 1 Sonderzeichen enthalten (kein Leerzeichen).',
  ERR_PASSWORD_DUPLICATE: 'Sie können das aktuelle Passwort nicht erneut verwenden',
  ERR_EMAIL_FAILED: 'Benutzererstellung fehlgeschlagen',
  ERR_MARKETPLACE_ITEM_NOT_ENABLED: 'Marktplatz-Element nicht aktiviert',
  ERR_EXISTING_PRODUCTS: 'Fortfahren nicht möglich aufgrund vorhandener Produkte',
  ERR_EXISTING_TENANT: 'Fortfahren nicht möglich aufgrund vorhandener Mandanten',
  ERR_ITEM_ALREADY_ACTIVATED: 'Das ausgewählte Marktplatz-Element ist bereits aktiv',
  ERR_JUICEGROUP_INVALID_LENGTH:
    'Der Name der Juice Group muss zwischen 3 und 64 Zeichen lang sein',
  ERR_JUICEGROUP_INVALID: 'Der Name der Juice Group ist ungültig',
  ERR_SCIM_UNSUPPORTED_SYNTAX: 'Nicht unterstützte SCIM-Filtersyntax',
  ERR_MARKETPLACE_ITEM_NOT_ALLOWED:
    'Das Marktplatz-Element ist für diese Organisation nicht zulässig',
  ERR_ADMIN_EXISTS: 'Für diese Organisation existiert bereits ein Administrator',

  /* Onboarding */
  onboardingWelcomeTitle: 'Willkommen bei TDI Connect',
  onboardingWelcomeDescription:
    'Ihre Identität wurde über Entra ID verifiziert. Um die Zugriffseinrichtung abzuschließen, geben Sie bitte unten den geschäftlichen Kontext an. Ein Administrator wird Ihre Anfrage prüfen und Sie einer Organisation zuweisen.',
  onboardingBusinessJustificationLabel: 'Geschäftliche Begründung',
  onboardingBusinessJustificationPlaceholder:
    'Erläutern Sie, warum Sie Zugriff auf TDI Connect benötigen',
  onboardingBusinessJustificationRequired: 'Eine geschäftliche Begründung ist erforderlich.',
  onboardingTeamLabel: 'Team / Abteilung',
  onboardingTeamPlaceholder: 'z. B. Platform Engineering',
  onboardingManagerLabel: 'Vorgesetzter',
  onboardingManagerPlaceholder: 'Name oder E-Mail-Adresse des Vorgesetzten',
  onboardingReferenceLabel: 'Referenz',
  onboardingReferencePlaceholder: 'Ticketnummer, Projektname oder Kontakt (optional)',
  onboardingEnterpriseNameLabel: 'Name der Organisation (falls bekannt)',
  onboardingEnterpriseNamePlaceholder: 'z. B. Deutsche Telekom AG',
  onboardingSubmissionFailed: 'Übermittlung fehlgeschlagen. Bitte versuchen Sie es erneut.',
  onboardingSubmitting: 'Wird gesendet…',
  onboardingSubmitRequest: 'Anfrage senden',

  /* Generic actions/labels (shared across many components) */
  submit: 'Absenden',
  cancel: 'Abbrechen',
  save: 'Speichern',
  okay: 'Okay',
  delete: 'Löschen',
  edit: 'Bearbeiten',
  formRequiredError: 'Erforderlich',
  optionalFieldSuffix: '(optional)',
  deleteFieldMismatch: 'Der eingegebene Wert muss mit dem aktuellen {name} übereinstimmen',
  deleteModalTitle: '{name} löschen',
  notAvailable: 'N/V',
  removeElement: 'Element entfernen',
  noSelection: 'Keine Auswahl',
  copyToClipboard: 'In die Zwischenablage kopieren',
  filter: 'Filter',
  uploadFile: 'Datei hochladen',
  clickToUpload: 'Zum Hochladen klicken',
  fileSizeExceedsLimit: 'Dateigröße überschreitet das Limit von {size}MB',
  filesUploadedInfo:
    '✓ {count, plural, one {# Datei} other {# Dateien}} hochgeladen ({size} KB insgesamt)',
  tagsLabel: 'Tags',
  noTagsAvailable: 'Keine Tags verfügbar',
  search: 'Suche',
  apply: 'Anwenden',
  clear: 'Löschen',
  openHelpGuide: 'Hilfe-Anleitung öffnen',
  initializing: 'Wird initialisiert...',
  copyrightText: '© DT Europe Holding GmbH',
  contact: 'Kontakt',
  termsAndConditions: 'Allgemeine Geschäftsbedingungen',
  imprint: 'Impressum',
  dataPrivacy: 'Datenschutz',
  scrollToTop: 'Nach oben scrollen',
  switchToMonthView: 'Zur Monatsansicht wechseln',
  goToNextMonth: 'Zum nächsten Monat',
  goToPreviousMonth: 'Zum vorherigen Monat',
  switchToYearView: 'Zur Jahresansicht wechseln',

  /* Role labels */
  roleLabelAdmin: 'Admin',
  roleLabelTdiConnectAdmin: 'TDI Connect Admin',
  roleLabelSupport: 'Support',
  roleLabelTdiConnectSupport: 'TDI Connect Support',
  roleLabelCaasAdmin: 'CaaS Admin',
  roleLabelTdiConnectCaasAdmin: 'TDI Connect CaaS Admin',
  roleLabelAccountOwner: 'Account Owner',
  roleLabelTdiConnectAccountOwner: 'TDI Connect Account Owner',
  roleLabelAccountAssistant: 'Account Assistant',
  roleLabelTdiConnectAccountAssistant: 'TDI Connect Account Assistant',
  roleLabelTechnicalLead: 'Technical Lead',
  roleLabelTdiConnectTechnicalLead: 'TDI Connect Technical Lead',
  roleLabelDeveloper: 'Developer',
  roleLabelTdiConnectDeveloper: 'TDI Connect Developer',
  roleLabelUnknown: 'Unbekannt',

  /* Governance / Organizations (shared table column labels) */
  email: 'E-Mail',
  role: 'Rolle',
  status: 'Status',
  active: 'Aktiv',
  inactive: 'Inaktiv',
  usersGuideAriaLabel: 'Benutzeranleitung öffnen',
  organizationsGuideAriaLabel: 'Organisationsanleitung öffnen',
  usersGuide: 'Benutzeranleitung',
  organizationsGuide: 'Organisationsanleitung',
  marketplace: 'Marktplatz',
  createdBy: 'Erstellt von',

  /* Overview tables (shared row title labels) */
  crmId: 'CRM-ID',
  accountOwner: 'Kontoinhaber',
  description: 'Beschreibung',
  type: 'Typ',
  project: 'Projekt',
  juiceGroup: 'Juice Group',
  approved: 'Genehmigt',
  name: 'Name',
  clusterType: 'Cluster-Typ',
  clusterVersion: 'Cluster-Version',
  cloud: 'Cloud',
  deviceCount: 'Geräteanzahl',
  owner: 'Eigentümer',
  created: 'Erstellt',
  lastUpdated: 'Zuletzt aktualisiert',
  kubeConfig: 'KubeConfig',
  technicalLead: 'Technischer Ansprechpartner',
  cloudId: 'Cloud-ID',
  geoRedundancy: 'Geo-Redundanz',
  externalServices: 'Externe Dienste',
  phone: 'Telefon',
  slack: 'Slack',
  devProjectName: 'Name des Entwicklungsprojekts',
  openStackUserName: 'OpenStack-Benutzername:',
  openStackWorkingSourceFile: 'OpenStack-Arbeitsquelldatei:',
  horizonUrl: 'Horizon-URL:',

  /* Onboarding/Account/Error pages */
  onboardingUnavailable: 'Onboarding ist vorübergehend nicht verfügbar.',
  notificationsUnavailable: 'Benachrichtigungen sind vorübergehend nicht verfügbar.',
  changeCloudPassword: 'Cloud-Passwort ändern:',
  page404Message: 'Diese Seite ist leider nicht verfügbar.',
  backToHomepage: 'Zurück zur Startseite',
  somethingWentWrong: 'Etwas ist schiefgelaufen.',
  completingLogin: 'Anmeldung wird abgeschlossen...',
  privacyPolicy: 'Datenschutzrichtlinie',
  privacy: 'Datenschutz',
  password: 'Passwort',
  confirmPassword: 'Passwort bestätigen',
  accept: 'Akzeptieren',
  newPassword: 'Neues Passwort',
  retypeNewPassword: 'Neues Passwort wiederholen',
  secondaryNav: 'Sekundär',

  /* Reports / Organizations / Projects */
  juiceGroupsHeader: 'JUICE-Gruppen',
  juiceGroupsSubHeader:
    'Wählen Sie eine Juice-Gruppe aus der Tabelle aus, um deren Details anzuzeigen.',
  noProductSelected:
    'Kein Produkt zur Konfiguration ausgewählt! Bitte wählen Sie eines aus der Tabelle oben aus.',
  addNewExternalService: 'Neuen externen Dienst hinzufügen',
  add: 'Hinzufügen',
  geoRedundancyState: 'Geo-Redundanz-Status:',
  editJuiceGroupInfoTitle: 'Juice-Gruppen-Info bearbeiten',
  createNewContact: 'Neuen Kontakt erstellen',
  createNewProject: 'Neues Projekt erstellen',
  projectSubHeader:
    'Neue Projekte hinzufügen, deren Details bearbeiten oder ein Projekt auswählen, um dessen Produkte zu konfigurieren.',
  createNewProduct: 'Neues Produkt erstellen',
  createNewOrganization: 'Neue Organisation erstellen',
  editProjectTitle: 'Projekt {name} bearbeiten',
  editProductTitle: 'Produkt {name} bearbeiten',
  editOrganizationTitle: 'Organisation {name} bearbeiten',
  projectNameField: 'Projektname',
  productNameField: 'Produktname',
  productTypeField: 'Produkttyp',
  organizationNameField: 'Organisationsname',
  juiceGroupTags: 'Juice-Group-Tags',
  validatingJuiceGroup: 'Juice Group wird validiert...',
  slugValidationMessage:
    'Nur Kleinbuchstaben, keine Leerzeichen, keine Sonderzeichen (nur Bindestrich)',
  slugValidationMessageWithLetter:
    'Mit einem Buchstaben beginnen, nur Kleinbuchstaben, keine Leerzeichen, keine Sonderzeichen (nur Bindestrich)',
  juiceGroupFormatError:
    'Die Juice Group muss mit einem Buchstaben beginnen und darf nur Kleinbuchstaben, Zahlen und Bindestriche enthalten',
  juiceGroupMinLength: 'Die Juice Group muss mindestens 3 Zeichen lang sein',
  juiceGroupMaxLength: 'Die Juice Group darf höchstens 64 Zeichen lang sein',
  cloudSummaries: 'Cloud-Zusammenfassungen',
  productForecast: 'Produktprognose',
  productSettingsSubHeaderAdmin: 'Konfigurieren Sie die Einstellungen für dieses Produkt.',
  productSettingsSubHeaderReadOnly: 'Aktuelle Produkteinstellungen (nur Ansicht)',
  quota: 'Kontingent',
  vCPU: 'vCPU',
  ramGb: 'RAM (GB)',
  volumesGb: 'Volumes (GB)',
  objectStorageGb: 'Objektspeicher (GB)',
  floatingIps: 'Floating IPs',
  currentAllowed: 'Aktuell erlaubt',
  currentAllocated: 'Aktuell zugewiesen',
  storageGb: 'Speicher (GB)',
  cnType: 'CN-Typ',
  rootDiscGb: 'Root-Disk (GB)',
  standardStorageGb: 'Standardspeicher (GB)',
  cpuVendor: 'CPU-Hersteller',
  serverCount: 'Server #',
  storageVolumeGb: 'Speichervolumen (GB)',
  vCPUShared: 'vCPU (Shared)',
  vCPUDedicated: 'vCPU (Dedicated)',
  ramSharedGb: 'RAM (Shared)(GB)',
  ramDedicatedGb: 'RAM (Dedicated)(GB)',
  rootDiskLocalGb: 'Root-Disk lokal (GB)',
  rootDiskGb: 'Root-Disk (GB)',
  forecastSummaryHeading: 'Prognosezusammenfassung',
  virtualCloudSummaryHeading: 'Zusammenfassung der virtuellen Cloud',
  usageSummaryHeading: 'Nutzungszusammenfassung',

  /* Products / Compute */
  computeOsProjectOrdered: 'Compute-OS-Projekt bestellt',
  projectLabel: 'Projekt: ',
  productLabel: 'Produkt: ',
  dataCenterLabel: 'Rechenzentrum: ',
  projectNameLabel: 'Projektname: ',
  osProjectName: 'OS-Projektname',
  osProjectNamePlaceholder: 'Geben Sie einen Namen für Ihr OpenStack-Projekt ein',
  copyWorkingSourceFile: 'Arbeits-Quelldatei kopieren',
  configuration: 'Konfiguration',
  evaluationExpired: 'Ihr Recht zur Nutzung des kostenlosen Testprodukts ist abgelaufen.',
  evaluationNotEnabled: 'Das Testprodukt ist für Ihre Organisation nicht aktiviert.',
  evaluationNotAssigned: 'Sie sind dem Testprodukt nicht zugewiesen.',
  evaluationOsProjectOrdered: 'Test-OS-Projekt bestellt',
  projectDescriptionTitle: 'Projektbeschreibung',
  evaluationProductTitle: 'Testprodukt',
  evaluationFreeOfCharge: '(Kostenlos)',
  evaluationDescriptionIntro:
    'Das Testprodukt ermöglicht es Nutzern, mithilfe von Cloud-APIs und einer vollständigen Nutzerdokumentation Workloads auf pan-net.cloud bereitzustellen. Das Produkt umfasst 10 vCPUs, 10 GB RAM und 10 GB Storage. Das Produkt steht für einen Testzeitraum von 3 Monaten ab Bestellbestätigung zur Verfügung. Eine Organisation kann innerhalb eines Zeitraums von einem Jahr ab der Erstellung der Organisation im pan-net.cloud-Portal insgesamt 1 Testprodukt bestellen.',
  evaluationDescriptionGtc:
    'Für dieses Produkt gelten die Allgemeinen Geschäftsbedingungen (AGB) für die Nutzung von pan-net.cloud.',
  evaluationDescriptionProductSpec:
    'Die Produktspezifikation für Testprodukte gilt in der auf dem pan-net.cloud-Portal veröffentlichten Fassung.',
  evaluationDescriptionSla: 'Das Service Level Agreement ist für Testprodukte nicht anwendbar.',
  evaluationAllocatedToTrialProduct:
    'Ihr Compute-Paket ist dem Testprodukt Ihrer Organisation zugewiesen,',
  evaluationWillBeAllocatedToTrialProduct:
    'Ihr Compute-Paket wird dem Testprodukt Ihrer Organisation zugewiesen,',
  evaluationNavigateToProducts: 'Navigieren Sie zur Produktseite, indem Sie',
  evaluationClickHere: 'hier klicken',
  evaluationDefineOsProjectName: 'Legen Sie einen Namen für das OpenStack-Projekt (Tenant) fest:',
  virtualCpusAndMemoryLabel: 'Virtuelle CPUs und Arbeitsspeicher: ',
  cpuCores: 'CPU-Kerne',
  storageLabel: 'Speicher: ',
  storageDescription:
    'Fügen Sie Ihrem OpenStack-Projekt Blockspeicher hinzu. Blockspeicher kann dann an die von Ihnen erstellten Instanzen angehängt werden.',
  floatingIpsLabel: 'Floating IPs',
  floatingIpsDescription:
    'Mit einer Floating IP können Sie schnell Zugriff von einem externen Netzwerk auf die Instanz ohne öffentliche Netzwerkschnittstelle bereitstellen.',
  product: 'Produkt',
  internetConnectivity: 'Internetverbindung',
  dthConnectivity: 'DTH-Verbindung',
  dthRedRouterConnectivity: 'DTH-Red-Router-Verbindung',

  /* Product details (non-CaaS) */
  from: 'Von',
  to: 'Bis',
  cloudReportDescription:
    'Aktivieren Sie einen Zeitraum, für den Sie Cloud-Berichte erhalten möchten.',
  cloudReportDownloadError:
    'Beim Herunterladen des Berichts ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  fromDateBeforeToDate: 'Das Startdatum muss vor dem Enddatum liegen',
  toDateBeforeToday: 'Das Enddatum muss vor oder gleich dem heutigen Datum sein',
  toDateAfterFromDate: 'Das Enddatum muss nach dem Startdatum liegen',
  virtualCloudSummaries: 'Virtuelle Cloud-Zusammenfassungen',
  selectCloudForHypervisors:
    'Wählen Sie eine Cloud aus, um die verfügbaren Hypervisoren anzuzeigen',
  noVirtualCloudsFound: 'Es wurden keine virtuellen Clouds gefunden',
  noForecastFound: 'Es wurde keine Prognose gefunden',

  /* CaaS cluster details */
  copyKubeConfig: 'KubeConfig kopieren',
  clusterNodes: 'Cluster-Knoten',
  clusterNodesFetchError: 'Beim Abrufen der Cluster-Knoten ist ein Fehler aufgetreten',
  currentVersion: 'Aktuelle Version',
  parent: 'Übergeordnet',
  close: 'Schließen',
  failedToLoadClusterDetails: 'Cluster-Details konnten nicht geladen werden',
  failedToLoadUpgradeStatus: 'Upgrade-Status konnte nicht geladen werden',
  error: 'Fehler',
  failedToLoadValidationResults: 'Validierungsergebnisse konnten nicht geladen werden',
  clusterCannotBeUpgradedYet: 'Dieser Cluster kann noch nicht aktualisiert werden',
  clusterStatus: 'Cluster-Status',
  clusterReroll: 'Cluster-Reroll',
  machinePlans: 'Machine Plans',
  pdbs: 'PDBs',
  podsNotRunning: 'Nicht laufende Pods',
  podsWithBitnamiImages: 'Pods mit Bitnami-Images',
  argoCdApplications: 'ArgoCD-Anwendungen',
  rerunValidation: 'Validierung erneut ausführen',
  clusters: 'Cluster',
  failed: 'Fehlgeschlagen',
  completed: 'Abgeschlossen',
  statusRefreshFailed: 'Statusaktualisierung fehlgeschlagen',
  statusRefreshFailedText:
    'Der aktuelle Upgrade-Status konnte nicht abgerufen werden. Klicken Sie auf "Jetzt aktualisieren", um es erneut zu versuchen.',
  upgradeDetails: 'Upgrade-Details',
  targetVersion: 'Zielversion',
  requestor: 'Anforderer',
  triggeredAt: 'Ausgelöst am',
  upgradeProgress: 'Upgrade-Fortschritt',
  masterNodes: 'Master-Knoten',
  workerGroups: 'Worker-Gruppen',
  functions: 'Funktionen',
  refreshNow: 'Jetzt aktualisieren',
  clusterCheckFetchError: 'Fehler beim Abrufen der Cluster-Prüfdaten',
  kubeconfigFetchError: 'Fehler beim Abrufen der Cluster-Kubeconfig',
  clusterStatusCheckModalTitle: 'Cluster-Statusprüfung: {name}',
  copy: 'Kopieren',
  kubeConfigModalTitle: 'KubeConfig für {name}',
  clusterStatusCheck: 'Cluster-Statusprüfung',
  upgrades: 'Upgrades',
  requestClusterUpgrade: 'Cluster-Upgrade anfordern',
  upgradeToVersion: 'Auf {version} upgraden',
  upgrade: 'Upgrade',
  upgradeInProgressSupportTextBeforeLink: 'Sie können dieses Fenster schließen — Sie erhalten eine',
  notificationLinkText: 'Benachrichtigung',
  upgradeInProgressSupportTextAfterLink: 'sobald das Upgrade abgeschlossen ist.',
  needHelp: 'Benötigen Sie Hilfe?',
  contactSupport: 'Support kontaktieren',
  tryAgain: 'Erneut versuchen',
  newUpgrade: 'Neues Upgrade',
  upgradeClusterModalTitle: 'Cluster upgraden: {name}',
  loadingClusterDetails: 'Cluster-Details werden geladen…',
  upgradeStatusTitle: 'Upgrade-Status',
  selectVersionToUpgrade: 'Wählen Sie die Version für das Upgrade *',
  selectAVersion: 'Version auswählen *',
  unlocksAfterValidation:
    'Wird freigeschaltet, sobald die Vor-Upgrade-Validierung erfolgreich war.',
  clusterNotEligibleForUpgrade: 'Cluster ist nicht für ein Upgrade geeignet',
  upgradeConfirmationCheckbox:
    'Ich bestätige, dass ich die Auswirkungen dieses Cluster-Upgrades verstehe und mich mit den erforderlichen Stakeholdern abgestimmt habe *',
  preUpgradeValidation: 'Vor-Upgrade-Validierung',

  /* Product details tabs / JuiceGroup & cluster table columns */
  osProjects: 'OS-Projekte',
  cloudReport: 'Cloud-Bericht',
  contacts: 'Kontakte',
  version: 'Version',
  group: 'Gruppe',
  hostname: 'Hostname',
  flavor: 'Flavor',
  cpu: 'CPU',
  memory: 'Arbeitsspeicher',
  disk: 'Festplatte',
  productNameColumn: 'Produktname',
  projectNameColumn: 'Projektname',
  expirationDate: 'Ablaufdatum',
  export: 'Exportieren',
  create: 'Erstellen',
  action: 'Aktion',

  /* Account Security / Password pages */
  cloudPassword: 'Cloud-Passwort',
  confirmNewPasswordField: 'Neues Passwort bestätigen',
  changePasswordButton: 'Passwort ändern',
  emailAddress: 'E-Mail-Adresse',
  genericErrorOccurred: 'Ein Fehler ist aufgetreten',
  passwordResetTitle: 'Passwort zurücksetzen',
  resetPasswordTitle: 'Passwort zurücksetzen',
  resetPasswordInstructions:
    'Geben Sie Ihre Portal-E-Mail-Adresse ein, um einen Link zum Zurücksetzen des Passworts zu erhalten:',

  /* User activation / Terms */
  userActivationTitle: 'Benutzeraktivierung',
  invitedToOrganization:
    'Sie wurden zu {organizationName} eingeladen. Bitte erstellen Sie Ihr Passwort.',
  readAboutDtCloudServices: 'Mehr über DT Cloud Services erfahren',
  here: 'hier',
  termsIntroBeforeLink:
    'Durch den Zugriff auf dieses Webportal bestätigen und erkennen Sie ausdrücklich an, dass Sie offiziell autorisiert und als " IaaS "-Nutzer benannt sind, um Ihr Arbeitgeberunternehmen (als "Service Receiver") zu vertreten, während Sie Aktivitäten gemäß den Allgemeinen Geschäftsbedingungen durchführen, die unter folgendem Link zu finden sind',
  generalTermsAndConditionsLinkText: 'Allgemeine Geschäftsbedingungen',
  termsIntroAfterLink:
    'welche von Ihnen wie unten gefordert ausdrücklich akzeptiert werden müssen.',
  termsSecondParagraph:
    'Bevor Sie die oben genannten Allgemeinen Geschäftsbedingungen und die Vereinbarung zur Verarbeitung personenbezogener Daten akzeptieren, lesen Sie diese bitte sorgfältig durch und stellen Sie sicher, dass Sie die Bedingungen und Bestimmungen verstehen, da Sie sich durch die Annahme dieser Bedingungen ausdrücklich bereit erklären, diese bei der Nutzung von "IaaS" anzuwenden.',
  termsThirdParagraphBeforeLink:
    'Durch die Annahme der oben genannten Allgemeinen Geschäftsbedingungen werden Sie darüber informiert, dass Sie unter folgendem Link',
  termsThirdParagraphAfterLink:
    'unsere "Datenschutzinformationen für das DT Cloud Services Portal" finden, ausschließlich zu Ihrer eigenen Information und Kenntnisnahme.',

  /* Error pages */
  thankYouForYourInterest: 'Vielen Dank für Ihr Interesse!',
  checkAddressAndRetry: 'Bitte überprüfen Sie die Adresse und versuchen Sie es erneut.',
  apologies: 'Entschuldigung.',
  weAreWorkingOnIt: 'Wir arbeiten daran.',
  tokenExpiredTitle: 'Etwas ist schiefgelaufen!',
  tokenExpiredMessage: 'Ihr Link ist leider abgelaufen. Bitte starten Sie den Vorgang erneut.',
  tokenExpiredContactSupport:
    'Falls dies nicht möglich ist, wenden Sie sich bitte an unser Support-Team.',

  /* Cookie Banner */
  partnerList: 'Partnerliste (2)',

  /* Users (OrganizationDetails) */
  createNewUser: 'Neuen Benutzer erstellen',
  editUserTitle: 'Benutzer bearbeiten: {email}',

  /* CaaS cluster upgrade progress */
  functionsStatus: 'Funktionsstatus',
  allFunctionsCompleted: 'Alle Funktionen abgeschlossen',
  waiting: 'Warten',
  loadingLabel: '{label} wird geladen',
  issuesCount: '{count, plural, one {# Problem} other {# Probleme}}',
  allHealthy: 'alles in Ordnung',
  showLess: 'Weniger anzeigen',
  showMore: '{count} weitere anzeigen',
  runningLabel: 'Läuft',
  passed: 'Bestanden',
  pendingLabel: 'Ausstehend',
  platformFunctionsPhase: 'Plattformfunktionen',
  postUpgradeCheckPhase: 'Nach-Upgrade-Prüfung',
  doneLabel: 'Fertig',
  progressingLabel: 'In Bearbeitung',
  readyLabel: 'Bereit',
  postUpgradeCheckFailedTitle: 'Nach-Upgrade-Prüfung fehlgeschlagen',
  postUpgradeCheckFailedTextWithVersion:
    'Der Cluster wurde auf {version} aktualisiert, aber die automatische Nachprüfung ist fehlgeschlagen. Überprüfen Sie den Cluster manuell, bevor Sie sich darauf verlassen.',
  postUpgradeCheckFailedTextNoVersion:
    'Der Cluster wurde aktualisiert, aber die automatische Nachprüfung ist fehlgeschlagen. Überprüfen Sie den Cluster manuell, bevor Sie sich darauf verlassen.',
  upgradeCompleteTitle: 'Upgrade abgeschlossen',
  upgradeCompleteText:
    'Der Cluster läuft jetzt mit {version} und hat die Nach-Upgrade-Prüfung bestanden.',
  theNewVersionFallback: 'der neuen Version',
  upgradingTitle: 'Upgrade läuft',
  upgradingTitleWithVersion: 'Upgrade auf {version} läuft',
  upgradeInProgressBannerText:
    'Dies kann eine Weile dauern. Der Vorgang läuft auch weiter, wenn Sie dieses Fenster schließen.',
  liveLabel: 'Live',
  noUpgradeRunning: 'Es läuft kein Upgrade',
  nodeWorkerDetailTitle: 'Node- und Worker-Details',
  waitingForPlatformFunctions: 'Warten auf Plattformfunktionen',

  /* Compute order form validation */
  spacesNotAllowed: 'Leerzeichen sind nicht erlaubt',
  exceedsAvailableQuota: 'Überschreitet das verfügbare Kontingent',
  mustBeGreaterThanZero: 'Muss größer als 0 sein',
  mustBeZeroOrGreater: 'Muss 0 oder größer sein',

  /* Compute order form */
  enterResourceAvailable: '{label} eingeben ({available} verfügbar)',
  ramLabel: 'RAM',
  diskQuotaLabel: 'Speicherkontingent',
  diskQuotaGb: 'Speicherkontingent (GB)',
  resourceNotAvailableSingular:
    '{resourceList} ist nicht verfügbar und wird zum Fortfahren benötigt',
  resourceNotAvailablePlural:
    '{resourceList} sind nicht verfügbar und werden zum Fortfahren benötigt',
  resourceCalculationInstructions:
    'Berechnen Sie die Gesamtzahl der benötigten Ressourcen, indem Sie die Ressourcen der geplanten Instanzen addieren. Die Liste der verfügbaren Instanztypen finden Sie',
  dthConnectivityWithInternetRedRouter: 'DTH-Internetverbindung (Red Router)',
  noVirtualCloudsForProduct: 'Keine virtuellen Clouds für das ausgewählte Produkt verfügbar',
  noProductsForProject: 'Keine Produkte für das ausgewählte Projekt verfügbar',
  noProjectsAvailable: 'Keine Projekte verfügbar',

  /* Sidebar navigation header */
  telecomLogoAlt: 'Telekom-Logo T',
  tdiConnectLogoAlt: 'TDI Connect Logo',

  /* Compute order page */
  openstackProjectRequest: 'OpenStack-Projektanfrage',

  /* Compute order - Network Connectivity */
  internetConnectivityDescription:
    'Diese Option umfasst die angeforderte (vordefinierte) Anzahl öffentlicher Floating IPs, die Erstellung eines internen Netzwerks und die Erstellung eines virtuellen Routers, der für die Internetanbindung konfiguriert ist.',
  internetConnectivityDisabledDescription:
    'Falls diese Option deaktiviert ist, werden nur die angeforderten Floating IPs bereitgestellt, und es werden keine Netzwerke oder Router erstellt. Die Internetanbindung kann später über die JUICE-API konfiguriert werden.',
  dthConnectivityDescription:
    'Diese Option umfasst die angeforderte (vordefinierte) Anzahl von DTH-Floating-IPs, die Erstellung eines internen Netzwerks und die Erstellung eines virtuellen Routers, der für die DTH-Anbindung konfiguriert ist.',
  dthConnectivityDisabledDescription:
    'Falls diese Option deaktiviert ist, werden nur die angeforderten Floating IPs bereitgestellt, und es werden keine Netzwerke oder Router erstellt. Die DTH-Anbindung kann später ebenfalls über die JUICE-API konfiguriert werden.',
  dthRedRouterConnectivityDescription:
    'Diese Option umfasst die angeforderte (vordefinierte) Anzahl von DTH-Floating-IPs, die Erstellung eines internen Netzwerks sowie die Erstellung eines virtuellen Routers, der für DTH- und Internetanbindung konfiguriert ist.',
  dthRedRouterConnectivityDisabledDescription:
    'Falls diese Option deaktiviert ist, werden nur die angeforderten Floating IPs bereitgestellt, und es werden keine Netzwerke oder Router erstellt. DTH- und Internetanbindung können später ebenfalls über die JUICE-API konfiguriert werden.',

  /* CaaS Clusters page */
  failedToLoadCaasClusterDetails: 'Fehler beim Laden der CaaS-Cluster-Details: {message}',
  noCaasClusterSelected:
    'Kein CaaS-Cluster ausgewählt! Bitte wählen Sie einen aus der Tabelle oben aus.',
};
